import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const ChronicleModal = ({ chapter, onClose }) => {
  if (!chapter) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
          className="bg-white dark:bg-slate-900 w-full max-w-2xl max-h-[80vh] rounded-2xl shadow-2xl flex flex-col border border-gray-100 dark:border-purple-800/50"
        >
          {/* Header */}
          <div className="flex justify-between items-center p-4 border-b border-gray-100 dark:border-purple-800/50">
            <div>
              <h3 className="text-lg font-black text-gray-900 dark:text-white">
                {chapter.title}
              </h3>
              <p className="text-xs text-gray-900 mt-1 dark:text-purple-500">
                {new Date(chapter.timestamp).toLocaleString()} • {chapter.content.length} entries
              </p>
            </div>
            <button
              onClick={onClose}
              className="p-2 bg-gray-50 hover:bg-gray-100 dark:bg-slate-800 dark:hover:bg-slate-700 text-gray-900 dark:text-purple-300 rounded-lg transition-colors"
            >
              <SafeIcon icon={FiIcons.FiX} />
            </button>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-6 space-y-6">
            {chapter.content.map((entry, idx) => (
              <div key={idx} className="leading-relaxed">
                <span className="font-black text-xs text-amber-600 uppercase tracking-widest mr-3">
                  {entry.role}
                </span>
                <span className="text-sm text-slate-700 dark:text-slate-300">
                  {entry.content}
                </span>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="p-4 border-t border-gray-100 dark:border-purple-800/50 flex justify-end">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-gray-100 hover:bg-purple-200 dark:bg-purple-900/50 dark:hover:bg-purple-800/50 text-gray-900 dark:text-purple-100 rounded-xl text-xs font-bold transition-colors"
            >
              Close
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ChronicleModal;
